import React from 'react'
import { UncontrolledTooltip } from 'reactstrap'

const SearchHelper = ({ helperText }) => {
    return (
        <UncontrolledTooltip
            placement="bottom"
            target="search-bar-0"
            trigger="hover"
        >{helperText}</UncontrolledTooltip>
    )
}

export default SearchHelper